import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export type MobileScreen = "locations" | "conditions" | "slots";

export const BOTTOM_SHEET_TYPES = {
  ADD_CONDITION: "ADD_CONDITION",
  EDIT_CONDITION: "EDIT_CONDITION",
  DATE_RANGE_PICKER: "DATE_RANGE_PICKER",
  QUICK_SETUP: "QUICK_SETUP",
} as const;

export type BottomSheetType = typeof BOTTOM_SHEET_TYPES[keyof typeof BOTTOM_SHEET_TYPES] | null;

interface BottomSheetState {
  type: BottomSheetType;
  props?: Record<string, any>;
}

interface MobileState {
  loading: boolean;
  activeScreen: MobileScreen | null;
  bottomSheet: BottomSheetState;
}

const initialState: MobileState = {
  loading: false,
  activeScreen: null,
  bottomSheet: { type: null },
};

const mobileSlice = createSlice({
  name: "mobile",
  initialState,
  reducers: {
    setMobileLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    navigateTo: (state, action: PayloadAction<MobileScreen>) => {
      state.activeScreen = action.payload;
    },
    goBack: (state) => {
      if(state.activeScreen === "slots") {
        state.activeScreen = "conditions";
      } else if(state.activeScreen === "conditions") {
        state.activeScreen = "locations";
      } else {
        state.activeScreen = null;
      }
    },
    resetNavigation: (): MobileState => {
      return {
        ...initialState,
        activeScreen: 'locations',
      };
    },
    openBottomSheet: (state, action: PayloadAction<{ type: NonNullable<BottomSheetType>; props?: Record<string, any> }>) => {
      state.bottomSheet = action.payload;
    },
    closeBottomSheet: (state) => {
      state.bottomSheet = { type: null };
    },
  },
});

export const selectMobileActiveScreen = (state: RootState) => state.mobile.activeScreen;
export const selectBottomSheet = (state: RootState) => state.mobile.bottomSheet;
export const selectBottomSheetType = (state: RootState) => state.mobile.bottomSheet.type;

export const {
  setMobileLoading,
  navigateTo,
  goBack,
  resetNavigation,
  openBottomSheet,
  closeBottomSheet,
} = mobileSlice.actions;

export default mobileSlice.reducer;
